/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Title_2_PostInputs */

const tr_landing_intro_title_2_post = /** @type {(inputs: Landing_Intro_Title_2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'dan başlıyor.`)
};

const en_landing_intro_title_2_post = /** @type {(inputs: Landing_Intro_Title_2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` a month.`)
};

const de_landing_intro_title_2_post = /** @type {(inputs: Landing_Intro_Title_2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` im Monat.`)
};

const ru_landing_intro_title_2_post = /** @type {(inputs: Landing_Intro_Title_2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` в месяц.`)
};

/**
* | output |
* | --- |
* | "a month." |
*
* @param {Landing_Intro_Title_2_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_title_2_post = /** @type {((inputs?: Landing_Intro_Title_2_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Title_2_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_title_2_post(inputs)
	if (locale === "de") return de_landing_intro_title_2_post(inputs)
	if (locale === "ru") return ru_landing_intro_title_2_post(inputs)
	return tr_landing_intro_title_2_post(inputs)
});